
function Landing(){

	this.build();
	barbaCallbacks.push(this);

}

Landing.prototype.build = function(){


	$('.btn-cta').magnificPopup({
		type: 'inline',
		preloader: false,
		mainClass: 'popup-landing'
	});

};
